import React from 'react';
import {
    Alert,
    Box,
    Button,
    Card,
    CircularProgress,
    TextField,
    Typography,
    useTheme,
} from "@mui/material";
import {
    LockRounded,
    SendRounded,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const _SupportReplyBox = ({
    isClosed,
    statusConfig,
    replyText,
    setReplyText,
    handleKeyDown,
    handleSendMessage,
    sending,
}) => {
    const theme = useTheme();
    const navigate = useNavigate();

    if (isClosed) {
        return (
            <Alert
                severity="info"
                icon={<LockRounded />}
                sx={{
                    borderRadius: 3.5,
                    p: 2,
                    border: '1px solid',
                    borderColor: 'info.light',
                }}
                action={
                    <Button
                        color="inherit"
                        size="small"
                        variant="outlined"
                        onClick={() => navigate('/support')}
                        sx={{ borderRadius: 2, fontWeight: 700 }}
                    >
                        مشاهده سایر تیکت‌ها
                    </Button>
                }
            >
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    این تیکت با وضعیت «{statusConfig.label}» خاتمه یافته است و امکان ارسال پیام جدید وجود ندارد. در صورت نیاز به راهنمایی بیشتر، می‌توانید تیکت جدیدی ایجاد کنید.
                </Typography>
            </Alert>
        );
    }

    return (
        <Card
            elevation={0}
            sx={{
                borderRadius: 4,
                border: '1px solid',
                borderColor: 'divider',
                bgcolor: 'background.paper',
                p: 2,
                boxShadow: '0 8px 30px rgba(0,0,0,0.06)',
            }}
        >
            <Box component="form" onSubmit={handleSendMessage}>
                <TextField
                    fullWidth
                    multiline
                    minRows={3}
                    maxRows={6}
                    placeholder="پاسخ خود را اینجا بنویسید... (یا کلیدهای Ctrl + Enter را جهت ارسال سریع بفشارید)"
                    value={replyText}
                    onChange={(e) => setReplyText(e.target.value)}
                    onKeyDown={handleKeyDown}
                    disabled={sending}
                    variant="outlined"
                    sx={{
                        mb: 1.5,
                        '& .MuiOutlinedInput-root': {
                            borderRadius: 3,
                            bgcolor: 'action.hover',
                        },
                    }}
                />

                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography variant="caption" color="text.secondary">
                        میانگین پاسخگویی کارشناسان در ساعات اداری: کمتر از ۲ ساعت
                    </Typography>

                    <Button
                        type="submit"
                        variant="contained"
                        disabled={sending || !replyText.trim()}
                        startIcon={sending ? <CircularProgress size={18} color="inherit" /> : <SendRounded sx={{ transform: 'rotate(180deg)' }} />}
                        sx={{
                            borderRadius: 2.5,
                            px: 3.5,
                            py: 1,
                            fontWeight: 700,
                            boxShadow: '0 4px 12px rgba(45, 107, 226, 0.25)',
                        }}
                    >
                        {sending ? "در حال ارسال..." : "ارسال پیام"}
                    </Button>
                </Box>
            </Box>
        </Card>
    );
};

export default _SupportReplyBox;
